import {Injectable} from '@angular/core';
import {Action, createSelector, State, StateContext} from '@ngxs/store';
import {UmpireOttFormat} from '@tisa-group/models';
import {LoadFormat} from './format.actions';
import {patch} from '@ngxs/store/operators';
import {OttFormatService} from '@tisa-group/core/api/umpire';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {JsonApiResponse} from '@tisa-group/cdk';

export type FormatStateModel = Record<string, JsonApiResponse<UmpireOttFormat>>;

@State<FormatStateModel>({
  name: 'Format',
  defaults: {},
})
@Injectable()
export class FormatState {
  @Action(LoadFormat)
  loadFormat(
    ctx: StateContext<FormatStateModel>,
    action: LoadFormat,
  ): Observable<JsonApiResponse<UmpireOttFormat>> | JsonApiResponse<UmpireOttFormat> {
    const stateFormat = ctx.getState()[action.slug];

    if (stateFormat) {
      return stateFormat;
    }

    return this.formatService
      .fetch(action.slug, {
        include: ['image', 'segments', 'tags'].join(','),
      })
      .pipe(
        tap(res =>
          ctx.setState(
            patch({
              [res.data.slug as string]: res,
            }),
          ),
        ),
      );
  }

  static getFormatBySlug(
    slug: string,
  ): (state: FormatStateModel) => JsonApiResponse<UmpireOttFormat> {
    return createSelector<(state: FormatStateModel) => JsonApiResponse<UmpireOttFormat>>(
      [FormatState],
      state => {
        return state[slug];
      },
    );
  }

  constructor(readonly formatService: OttFormatService) {}
}
